import React from 'react';
import { Select } from 'antd';
import { useFilters } from '../FilterContext';
import { useMasters } from '../MastersContext';

const slices = [
  { key: 'today', label: 'Today' },
  { key: '1w', label: '1W' },
  { key: '1m', label: '1M' },
  { key: '3m', label: '3M' },
  { key: '6m', label: '6M' },
  { key: 'all', label: 'All' },
];

const GlobalFilterBar = () => {
  const { filters, setFilter, setDateSlice, clearFilters } = useFilters();
  const { masters } = useMasters();

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 5, padding: '4px 16px',
      backgroundColor: '#fff', borderBottom: '1px solid #d1d5db', flexWrap: 'wrap',
      flexShrink: 0,
    }}>
      {/* Date label */}
      <span style={{
        fontSize: 8, fontWeight: 700, textTransform: 'uppercase',
        letterSpacing: 0.4, color: '#9ca3af', whiteSpace: 'nowrap',
      }}>
        Date
      </span>

      {/* Quick slices */}
      <div style={{ display: 'flex', gap: 2 }}>
        {slices.map(s => (
          <button key={s.key} onClick={() => setDateSlice(s.key)} style={{
            padding: '2px 6px', fontSize: 9, fontWeight: 600, borderRadius: 3,
            border: filters.dateSlice === s.key ? '1px solid #2563eb' : '1px solid #d1d5db',
            cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.12s',
            backgroundColor: filters.dateSlice === s.key ? '#2563eb' : '#f9fafb',
            color: filters.dateSlice === s.key ? '#fff' : '#4b5563',
          }}>
            {s.label}
          </button>
        ))}
      </div>

      {/* Custom date inputs */}
      <input type="date" value={filters.dateFrom} onChange={e => { setFilter('dateFrom', e.target.value); setFilter('dateSlice', 'custom'); }}
        style={{
          padding: '2px 5px', border: '1px solid #d1d5db', borderRadius: 4,
          fontFamily: "'JetBrains Mono', monospace", fontSize: 9, color: '#111827',
          background: '#f9fafb', outline: 'none', maxWidth: 96,
        }}
        onFocus={e => e.target.style.borderColor = '#2563eb'}
        onBlur={e => e.target.style.borderColor = '#d1d5db'}
      />
      <span style={{ color: '#9ca3af', fontSize: 10 }}>–</span>
      <input type="date" value={filters.dateTo} onChange={e => { setFilter('dateTo', e.target.value); setFilter('dateSlice', 'custom'); }}
        style={{
          padding: '2px 5px', border: '1px solid #d1d5db', borderRadius: 4,
          fontFamily: "'JetBrains Mono', monospace", fontSize: 9, color: '#111827',
          background: '#f9fafb', outline: 'none', maxWidth: 96,
        }}
        onFocus={e => e.target.style.borderColor = '#2563eb'}
        onBlur={e => e.target.style.borderColor = '#d1d5db'}
      />

      {/* Separator */}
      <div style={{ width: 1, height: 16, backgroundColor: '#d1d5db', flexShrink: 0 }} />

      {/* Filter dropdowns */}
      <Select size="small" placeholder="Market" allowClear value={filters.market || undefined}
        onChange={v => setFilter('market', v || '')} style={{ width: 90, fontSize: 10 }}
        options={masters.markets.map(m => ({ value: m.value, label: m.value }))} />

      <Select size="small" placeholder="Type" allowClear value={filters.analysisType || undefined}
        onChange={v => setFilter('analysisType', v || '')} style={{ width: 100, fontSize: 10 }}
        options={masters.analysisTypes.map(m => ({ value: m.value, label: m.value }))} />

      <Select size="small" placeholder="Status" allowClear value={filters.status || undefined}
        onChange={v => setFilter('status', v || '')} style={{ width: 100, fontSize: 10 }}
        options={['Pending','Running','Completed','Cancelled'].map(s => ({ value: s, label: s }))} />

      <Select size="small" placeholder="Product" allowClear showSearch value={filters.product || undefined}
        onChange={v => setFilter('product', v || '')} style={{ width: 140, fontSize: 10 }}
        options={masters.products.map(m => ({ value: m.value, label: m.value }))} />

      <Select size="small" placeholder="Test" allowClear showSearch value={filters.test || undefined}
        onChange={v => setFilter('test', v || '')} style={{ width: 120, fontSize: 10 }}
        options={masters.tests.map(m => ({ value: m.value, label: m.value }))} />

      {/* Clear */}
      <button onClick={clearFilters} style={{
        marginLeft: 'auto', border: 'none', background: 'none', color: '#2563eb',
        fontSize: 9, fontWeight: 600, cursor: 'pointer', padding: '2px 6px', borderRadius: 3,
      }}
        onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
        onMouseLeave={e => e.currentTarget.style.background = 'none'}
      >
        ✕ Clear
      </button>
    </div>
  );
};

export default GlobalFilterBar;
